import { connect } from 'react-redux';
import PengajuanLembur from '../../../views/Personnel/Absensi/PengajuanLembur.absensi.view';
import { getAssignment } from '../../../states/thunks/personnel.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAssignment: payload => dispatch(getAssignment(payload)),
  };
}

export default connect(null, mapDispatchToProps)(PengajuanLembur);